export const MI_PAGO_HARTU_FUNCIONALITY = 'hartu'

export const HARTU_BOOKING_STATUS_ACTIVE = 1
export const HARTU_BOOKING_STATUS_PENDING = 4
export const HARTU_BOOKING_STATUS_CANCELLED = 3
export const HARTU_BOOKING_STATUS_PAST = 2

export const HARTU_FACILITY_PHONE = 2
export const HARTU_FACILITY_SPACE = 1

export const HARTU_PELLETS_1 = 8.2
export const HARTU_PELLETS_2 = 14.4

export const HARTU_ABONADO_JAI_ALAI = -5
export const HARTU_ABONADO_PADEL = -4

export const FIELD_TYPES = {
    TEXTBOX: 'TEXTBOX',
    NUMBER: 'NUMBER',
    TEXTAREA: 'TEXTAREA',
    DDL: 'DDL',
    LABEL: 'LABEL',
    HIDDEN: 'HIDDEN',
    CUENTA_BANCARIA: 'CUENTABANCARIA',
    CHECKBOX: 'CHECKBOX',
}

